import { Stack, Typography } from "@mui/material";

export default function SeasonTicketStatus({ seasonTicket }) {
    if (!seasonTicket) return null
    const { hrc, endUserSeasonTicket, numberOfTicketsEligibleForDiscount } = seasonTicket
    const { entryPassTicketsUsed, entryPassTotalTicketsAllowed, seasonTicketType } = endUserSeasonTicket

    return (<>
        <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" sx={{ color: 'secondary.main' }}>
                <span>{seasonTicketType === "entry-pass" ? 'כרטיסייה' : 'מנוי'}</span>
                <span> - {hrc}</span>
            </Typography>
            {seasonTicketType === "entry-pass" && <Typography variant="body2" sx={{ color: 'secondary.main' }}>
                <span>
                    השתמשת ב {entryPassTicketsUsed} מתוך {entryPassTotalTicketsAllowed}
                </span>
            </Typography>}
        </Stack>
        {numberOfTicketsEligibleForDiscount > 0 && <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" sx={{ color: 'secondary.main' }}>
                <span> כניסות שניתן לממש באירוע זה </span>
            </Typography>
            <Typography variant="body2" sx={{ color: 'secondary.main' }}>
                <span>{numberOfTicketsEligibleForDiscount}</span>
            </Typography>
        </Stack>}
        {numberOfTicketsEligibleForDiscount == 0 && <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" sx={{ color: 'secondary.main' }}>
                <span> לא נותרו לך כניסות למימוש באירוע זה  </span>
            </Typography>
        </Stack>}
    </>
    )
}
